<template>
  <nav class="top-nav">
    <div class="nav-inner">
      <router-link to="/" class="nav-logo">guojiadaima.com</router-link>
      <div class="nav-links">
        <router-link to="/" class="nav-link" exact-active-class="active">国家代码表</router-link>

        <!-- 时间工具下拉菜单 -->
        <div class="nav-dropdown"
          @mouseenter="onDropdownEnter"
          @mouseleave="onDropdownLeave">
          <span class="nav-link nav-dropdown-trigger"
            :class="{ active: isTimeRoute }"
            @click.stop.prevent="toggleDropdown">
            时间工具
            <span class="arrow" :class="{ open: dropdownOpen }">&#9660;</span>
          </span>
          <transition name="dd-fade">
            <div class="dropdown-menu" v-show="dropdownOpen">
              <router-link to="/tools" class="dropdown-item" active-class="active-item">时间工具首页</router-link>
              <router-link to="/clock" class="dropdown-item" active-class="active-item">专注时钟</router-link>
              <router-link to="/alarm" class="dropdown-item" active-class="active-item">闹钟</router-link>
              <router-link to="/calendar" class="dropdown-item" active-class="active-item">日历</router-link>
              <router-link to="/convert" class="dropdown-item" active-class="active-item">时区转换</router-link>
              <router-link to="/calculator" class="dropdown-item" active-class="active-item">时间计算器</router-link>
              <router-link to="/age" class="dropdown-item" active-class="active-item">年龄计算</router-link>
              <router-link to="/unix" class="dropdown-item" active-class="active-item">Unix 时间戳转换</router-link>
              <router-link to="/holidays" class="dropdown-item" active-class="active-item">节假日</router-link>
              <router-link to="/cities" class="dropdown-item" active-class="active-item">全球城市</router-link>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TopNav',
  data () {
    return {
      dropdownOpen: false,
      isTouch: 'ontouchstart' in window
    }
  },
  computed: {
    isTimeRoute () {
      const timeRoutes = ['/tools', '/clock', '/alarm', '/calendar', '/convert', '/calculator', '/age', '/unix', '/holidays', '/cities']
      const cityDetail = this.$route.path.startsWith('/city/')
      return timeRoutes.includes(this.$route.path) || cityDetail
    }
  },
  methods: {
    onDropdownEnter () {
      if (!this.isTouch) { this.dropdownOpen = true }
    },
    onDropdownLeave () {
      if (!this.isTouch) { this.dropdownOpen = false }
    },
    toggleDropdown () {
      this.dropdownOpen = !this.dropdownOpen
    },
    onDocumentClick (e) {
      if (this.dropdownOpen && !this.$el.querySelector('.nav-dropdown').contains(e.target)) {
        this.dropdownOpen = false
      }
    }
  },
  watch: {
    '$route' () {
      this.dropdownOpen = false
    }
  },
  mounted () {
    document.addEventListener('click', this.onDocumentClick)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.onDocumentClick)
  }
}
</script>

<style scoped>
.top-nav {
  background: #1a1a2e;
  position: sticky;
  top: 0;
  z-index: 200;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}
.nav-inner {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 48px;
}
.nav-logo {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  text-decoration: none;
  margin-right: 24px;
  white-space: nowrap;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 14px;
  font-size: 13px;
  color: #a0b4d0;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
}
.nav-link:hover { color: #fff; background: rgba(255,255,255,0.08); }
.nav-link.active { color: #fff; background: #1677ff; }

/* 下拉菜单 */
.nav-dropdown {
  position: relative;
}
.nav-dropdown-trigger {
  cursor: pointer;
}
.arrow {
  font-size: 9px;
  transition: transform 0.2s;
  margin-left: 1px;
}
.arrow.open {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  min-width: 140px;
  padding: 6px 0;
  z-index: 300;
}
.dropdown-item {
  display: block;
  padding: 10px 18px;
  font-size: 13px;
  color: #333;
  text-decoration: none;
  transition: all 0.15s;
  white-space: nowrap;
}
.dropdown-item:hover {
  background: #f0f5ff;
  color: #1677ff;
}
.dropdown-item.active-item {
  background: #e6f4ff;
  color: #1677ff;
  font-weight: 600;
}

/* 下拉动画 */
.dd-fade-enter-active, .dd-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.dd-fade-enter-from, .dd-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (max-width: 480px) {
  .nav-link { padding: 8px 10px; font-size: 12px; }
  .nav-logo { font-size: 14px; margin-right: 12px; }
}
</style>
